import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect } from "react";

import { queryClient, router } from "./router";
import { useUserStore } from "./store/zustand/useUserStore";

function InnerApp() {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (!user) {
      router.invalidate();
    }
  }, [user]);

  return <RouterProvider router={router} context={{ auth: user }} />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <InnerApp />
    </QueryClientProvider>
  );
}
